import React from "react";
import { Modal, Table, Button } from "react-bootstrap";

function ViewSettingModal({ show, onHide, setting }) {
  if (!setting) return null;

  return (
    <Modal show={show} onHide={onHide} size="md" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Group Settings</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table bordered size="sm" className="mb-0">
          <tbody>
            <tr>
              <th width="40%">Setting Name</th>
              <td>{setting.setting_name || "NA"}</td>
            </tr>
            <tr>
              <th>DIDs Per Agent</th>
              <td>{setting.dids_per_agent ?? "NA"}</td>
            </tr>
            <tr>
              <th>Days To Spam</th>
              <td>{setting.days_to_spam ?? "NA"}</td>
            </tr>
            <tr>
              <th>Days To Shuffle</th>
              <td>{setting.days_to_shuffle ?? "NA"}</td>
            </tr>
            <tr>
              <th>Days To Assign Additional DID</th>
              <td>{setting.days_to_assign_additional_did ?? "NA"}</td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ViewSettingModal;
